export const OPEN_ADMANAGEMENT_DIALOG = "OPEN_ADMANAGEMENT_DIALOG";
export const CLOSE_ADMANAGEMENT_DIALOG = "CLOSE_ADMANAGEMENT_DIALOG";
